import React from 'react'
import injectSheet from 'react-jss'
import styles from './edit-dialog.styles'
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalContent
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import { Formik } from 'formik'
import FormTextArea from 'pobble-components/dist/form-elements/form-text-area'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import FormRow from '../../../../components/common/form-elements/form-row/form-row'

const LESSON_OVERVIEW_MAX_LENGTH = 200

const LessonOverviewSlideEditDialog = ({
  classes,
  modalOpened,
  onChange,
  onClose,
  onSubmit,
  updating,
  body
}) => (
  <Modal closeButton isOpen={modalOpened} requestClose={onClose}>
    <ModalHeader>Edit lesson overview</ModalHeader>
    <Formik onSubmit={onSubmit} initialValues={{ body: body || '' }}>
      {({ handleSubmit, handleBlur, handleChange, values }) => {
        return (
          <form onSubmit={handleSubmit} className="metrics__slide-form">
            <ModalContent legacy>
              <FormRow first>
                <FormLabel small spaceBetween htmlFor="updateLessonLo">
                  <span>Lesson overview</span>
                  <CharactersCount
                    value={values.body}
                    max={LESSON_OVERVIEW_MAX_LENGTH}
                  />
                </FormLabel>
                <FormTextArea
                  autoFocus
                  id="updateLessonLo"
                  name="body"
                  value={values.body}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  textAreaProps={{ maxLength: LESSON_OVERVIEW_MAX_LENGTH }}
                />
              </FormRow>
            </ModalContent>
            <ModalFooter alignRight childrenGap>
              <Button action={onClose} tall simple>
                Cancel
              </Button>
              <Button tall type="submit" disabled={updating}>
                {!updating && 'Save'}
                {updating && 'Saving'}
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(LessonOverviewSlideEditDialog)
